var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "so-no-selector" },
    [
      _c(
        "el-tooltip",
        { attrs: { placement: "bottom-end" } },
        [
          _c("div", {
            attrs: { slot: "content" },
            domProps: {
              innerHTML: _vm._s(_vm.tooltip || _vm.$t("SeaExport.NoData"))
            },
            slot: "content"
          }),
          _c("el-input", {
            attrs: { disabled: _vm.disabled, readonly: true },
            model: {
              value: _vm.firstLineVal,
              callback: function($$v) {
                _vm.firstLineVal = $$v
              },
              expression: "firstLineVal"
            }
          })
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "el-button el-button--primary el-button--mini",
          staticStyle: {
            "margin-left": "2px",
            width: "45px",
            "min-width": "45px"
          },
          on: {
            click: function($event) {
              _vm.showDialog = true
            }
          }
        },
        [_vm._v("...")]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.showDialog,
            title: _vm.$t("SeaExport.SelectSoNo"),
            width: "450px",
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "300px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          }),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  !_vm.disabled
                    ? _c(
                        "el-button",
                        { attrs: { type: "primary" }, on: { click: _vm.save } },
                        [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                      )
                    : _vm._e(),
                  _vm.disabled
                    ? _c(
                        "span",
                        {
                          staticClass: "el-button el-button--mini",
                          on: {
                            click: function($event) {
                              _vm.showDialog = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }